/* eslint no-unused-vars: ["warn", { "varsIgnorePattern": "[iI]gnored" }] */

import { restHelper } from '../helpers';
import constants from '../constants';
import { getReverseAddresses, setReverseAddresses } from "../helpers/storageHelper";
const { HERE_API_KEY } = constants;
// INFO we currently use freemium tier APP_ID / APP_CODE to keep support on long term restricted to some features functionalities only
// https://my-air.atlassian.net/browse/MYP-2573
const { HERE_APP_ID, HERE_APP_CODE } = constants;

// https://developer.here.com/documentation/places

// https://developer.here.com/documentation/geocoder-autocomplete/topics/resource-suggest.html
const AUTOCOMPLETE_URL = 'https://autocomplete.search.hereapi.com/v1/autocomplete';
const PLACES_AUTOSUGGEST_URL = 'https://autosuggest.search.hereapi.com/v1/autosuggest';
const GEOCODE_URL = 'https://geocode.search.hereapi.com/v1/geocode'; // INFO check if won't be used
const ROUTEMATCHING_URL = 'https://routematching.hereapi.com/v8/match/routelinks';
const REVERSE_GEOCODE_URL = 'https://revgeocode.search.hereapi.com/v1/revgeocode';
const ROUTING_URL = 'https://router.hereapi.com/v8/routes';
const LOOKUPBYID_URL = 'https://lookup.search.hereapi.com/v1/lookup';

const LTS__AUTOCOMPLETE_URL = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json';
const LTS__GEOCODE_URL = 'https://geocoder.api.here.com/6.2/geocode.json';
const LTS__REVERSE_GEOCODE_URL = 'https://reverse.geocoder.api.here.com/6.2/reversegeocode.json';

class HereService {
  constructor() {
    this.apiKey = HERE_API_KEY;
    // INFO we currently use freemium tier APP_ID / APP_CODE to keep support on long term restricted to some features functionalities only
    // https://my-air.atlassian.net/browse/MYP-2573
    this.appId = HERE_APP_ID;
    this.appCode = HERE_APP_CODE;
    //
  }

  // usage: setVehicleType({ engineType: 'diesel', fuelConsumption: '5.0' });
  // https://developer.here.com/documentation/routing/dev_guide/topics/resource-param-type-vehicle-type.html
  setVehicleType = ({ engineType, fuelConsumption }) => {
    this.engineType = engineType;
    this.fuelConsumption = fuelConsumption;
  };

  clearVehicleType = () => {
    this.engineType = undefined;
    this.fuelConsumption = undefined;
  };

  /**
   *
   * @param {*} searchText
   * @param {*} language IT, EN
   * @param {*} resultType houseNumber, intersection, street, postalCode, district, city, county, state, country
   */
  autocomplete(query, language = 'IT', resultType = 'street') {
    return restHelper.get(
        `${AUTOCOMPLETE_URL}?apiKey=${this.apiKey}&q=${query}&beginHighlight=<b>&endHighlight=</b>&lang=${language}`
    ).then((response) => {
      try {
        let { items } = response;
        items = items.map(item => {
          return {
            label: item.title,
            locationId: item.id
          }
        });
        return { suggestions: items };
      } catch (error) {
        return Promise.reject({ error, message: 'No data available' });
      }
    });
  }

  autocompleteLTS(query, language = 'IT', resultType = 'street') {
    return restHelper.get(
      `${LTS__AUTOCOMPLETE_URL}?app_id=${this.appId}&app_code=${this.appCode}&query=${query}&beginHighlight=<b>&endHighlight=</b>&language=${language}&resultType=${resultType}`
    );
  }

  geocode(q, language = 'IT', shapeLevel = 'default') {
    return restHelper.get(`${GEOCODE_URL}?apiKey=${this.apiKey}&q=${q}&language=${language}&additionaldata=IncludeShapeLevel,${shapeLevel}`).then((response) => {
      try {
        return response;
      } catch (error) {
        return Promise.reject({ error, message: 'No data available' });
      }
    });
  }

  geocodeLTS(locationid, language = 'IT', shapeLevel = 'default') {
    return restHelper.get(`${LTS__GEOCODE_URL}?app_id=${this.appId}&app_code=${this.appCode}&locationid=${locationid}&language=${language}&additionaldata=IncludeShapeLevel,${shapeLevel}`);
  }

  lookupbyid(locationid, language = 'IT', shapeLevel = 'default') {
    return restHelper.get(`${LOOKUPBYID_URL}?apiKey=${this.apiKey}&id=${locationid}&language=${language}`).then((response) => {
      try {
        return response;
      } catch (error) {
        return Promise.reject({ error, message: 'No data available' });
      }
    });
  }

  reverseGeocodeUncached(lat, lng, radius, mode = 'retrieveAddresses', shapeLevel = 'default') {
    const at = `${lat}%2C${lng}`;
    return restHelper.get(`${REVERSE_GEOCODE_URL}?apiKey=${this.apiKey}&at=${at}&lang=it-IT`)
  }

  reverseGeocodeUncachedLTS(lat, lng, radius, mode = 'retrieveAddresses', shapeLevel = 'default') {
    let prox = `${lat},${lng},${radius}`;
    return restHelper.get(`${LTS__REVERSE_GEOCODE_URL}?prox=${prox}&mode=${mode}&app_id=${this.appId}&app_code=${this.appCode}&additionaldata=IncludeShapeLevel,${shapeLevel}`);
  }

  reverseGeocode = async ( lat, lng, radius, mode = 'retrieveAddresses') => {
    const object = await getReverseAddresses({ latitude: lat, longitude: lng });
    if (object !== undefined && object.hasOwnProperty('data')) {
      return object.data;
    }
    return await this.reverseGeocodeUncached( lat, lng, radius, mode)
      .then( async ({ items }) => {
        try {
          const address = items[0].address;
          await setReverseAddresses({ latitude: lat, longitude: lng, data: address })
          return address;
        } catch (error) {
          return Promise.reject({ error, msg: 'Address is not available' });
        }
      });
    // return await this.reverseGeocodeUncached( lat, lng, radius, mode)
    // .then( async (response) => {
    //   try {
    //     const data = this.transformHERErevgeocode(response);
    //     await setReverseAddresses({ latitude: lat, longitude: lng, data })
    //     return data;
    //   } catch (error) {
    //     return Promise.reject({ error, msg: 'Address is not available' });
    //   }
    // });
  }

  matchroute(gpx) {
    return restHelper.postXml(`${ROUTEMATCHING_URL}?apiKey=${this.apiKey}&mode=fastest;car;traffic:disabled&routeMatch=1`, { xml: gpx });
  }

  places(q, at, resultType = 'place', size = 10) {
    return restHelper.get(`${PLACES_AUTOSUGGEST_URL}?apiKey=${this.apiKey}&q=${q}&at=${at}&result_types=${resultType}&limit=${size}`).then((response) => {
      try {
        // let { results } = response;
        // return results;
        let { items } = response;
        items = items.filter(item => item.hasOwnProperty('position') && item.position !== undefined).map(item => {
          return {
            id: item.id,
            highlightedTitle: item.title,
            position: [item.position.lat, item.position.lng],
            category: 'generic',
            vicinity: item.address.label
          }
        });
        return items;
      } catch (error) {
        return Promise.reject({ error, message: 'No data available' });
      }
    })
  }

  retrieveAddress = async (lat, lon, radius = '250') => {
    let address = await this.reverseGeocode(lat, lon, radius);
    return address.label;
  }

  route = async ({ fromLatLng, toLatLng }) => {
    const origin = `${fromLatLng.lat},${fromLatLng.lng}`;
    const destination = `${toLatLng.lat},${toLatLng.lng}`;
    return restHelper.get(
      `${ROUTING_URL}?apiKey=${this.apiKey}&origin=${origin}&destination=${destination}&routingMode=fast&transportMode=car&return=summary&units=metric&lang=it-IT`
    );
  };

  routeSummary = ({ fromLatLng, toLatLng }) => {
    return this.route({ fromLatLng, toLatLng }).then((response) => {
      try {
        const data = this.transformHERErouting(response);
        return data;
      } catch (error) {
        return Promise.reject({ error, message: 'No route available' });
      }
    });
  };

  transformHERErevgeocode = (input) => {
    // const { Response } = input;
    // const address = Response.View[0].Result[0].Location.Address;
    // delete address.AdditionalData;
    // const output = address;
    let { items: [ { address } ] } = input;
    let output = {};
    for (const key in address) {
      const k = key[0].toUpperCase() + key.slice(1);
      output[k] = address[key];
    }
    return output;
  };

  transformHERErouting = (input) => {
    // const { response: { route: [ { summary } ] } } = input;
    // return summary;
    const { routes: [ { sections: [ { summary } ] } ] } = input;
    const { duration: trafficTime, length: distance } = summary;
    const output = { trafficTime, distance };
    return output;
  };

}

export default HereService;



// WEBPACK FOOTER //
// ./src/services/Here.js